{
  "groups": {
    "referenceNumber": "参考号",
    "appointmentStartTimes": "预约开始时间",
    "appointmentNotifications": "预约通知",
    "appointmentStatuses": "预约状态",
    "customAppointmentsGrid": "自定义预约网格",
    "limiter": "限制器",
    "schedulingPortal": "预约门户",
    "dockSelection": "站台选择",
    "timeDisplay": "时间显示",
    "gateManagement": "闸口管理",
    "smartGate": "SmartGate",
    "idValidation": "身份验证",
    "appointmentValidation": "预约验证",
    "other": "其他",
    "handlingUnits": "装卸单元"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "参考号是承运商在预约时您可以要求其提供的参考信息。",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "确定允许预约开始的时间间隔。",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "管理此{entity}的所有类型的预约通知。",
    "manageTheSchedulingPortalSettingsForThisEntity": "管理此{entity}的预约门户设置",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "装卸单元是一个数字字段，用于在预约时请求单元数量（例如托盘）。将其添加到您的表单中，还可启用限制器功能。",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "限制器可让您设置每天可预约的预约数量或装卸单元（例如托盘）数量的上限。"
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "参考号最少数量",
    "maximumAmountOfReferenceNumbers": "参考号最多数量",
    "includeReferenceNumberFieldOnAllAppointmentForms": "是否在所有预约表单中包含参考号字段？",
    "referenceNumberFieldName": "参考号字段名称",
    "referenceNumberHelperText": "参考号帮助文本",
    "makeReferenceNumberARequiredField": "是否将参考号设为必填字段？",
    "allowAppointmentsForThisEntityToStartAt": "允许此{entity}的预约开始于：",
    "enableAppointmentNotificationsForThisEntity": "是否为此{entity}启用预约通知？",
    "selectEachDesiredStartTimeIndividually": "逐一选择所需的开始时间",
    "hideTheLoadTypeDuration": "是否隐藏货物类型时长？",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "上传您的{entity}标志，以便在预约门户和所有电子邮件通知中显示",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "上传您的仓库堆场地图，以便在预约门户中显示",
    "statusForNewlyCreatedAppointments": "新建预约的状态",
    "muteAppointmentNotifications": "静音预约通知",
    "allowDockSelectionInSchedulingPortal": "是否允许在预约门户中选择站台？",
    "theStatusThatFollowsArrivedIs": "“已到达”之后的状态为",
    "displayTimeIn": "时间显示格式：",
    "customizeAppointmentDetails": "自定义预约详情",
    "gridTileConfig": "网格卡片配置",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "强制启用地理围栏，要求司机提供其实时位置",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "是否要在司机签到后向其显示附加信息？（可选）",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "是否禁止在预约门户中改期预约？",
    "revertToRequestedOnCarrierReschedule": "承运商改期时恢复为“已申请”",
    "observationMatchAttribute": "观测匹配属性",
    "observationMatchTimeWindow": "观测匹配时间窗口",
    "autoDepartAssets": "资产自动离场",
    "autoCreateAssets": "自动创建资产",
    "gateFeedColumns": "Gate Feed 列",
    "checkInEarlyThreshold": "提前签到阈值",
    "checkInLateThreshold": "延迟签到阈值",
    "technicalContactEmailAddress": "技术联系人电子邮件地址",
    "technicalContactEmailThrottleMinutes": "技术联系人邮件发送间隔（分钟）",
    "requireUniqueReferenceNumbers": "要求参考号唯一",
    "appointmentStartTimeInterval": "预约开始时间间隔",
    "referenceNumberInputMode": "参考号输入模式",
    "uploadWarehouseYardMap": "上传您的仓库堆场地图，以便在预约门户中显示",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "是否在所有预约表单中包含装卸单元字段？",
    "handlingUnitsLabel": "装卸单元标签",
    "handlingUnitsHelperText": "装卸单元帮助文本",
    "makeHandlingUnitsARequiredField": "是否将装卸单元设为必填字段？",
    "maximumHandlingUnitsValueForAnAppointment": "单个预约的装卸单元最大值",
    "minimumHandlingUnitsValueForAnAppointment": "单个预约的装卸单元最小值",
    "checkOutBolSignedRequired": "签出时必须签署 BOL",
    "checkOutBolNotLoadingErrorMessage": "签出时 BOL 无法加载的错误信息",
    "checkOutIdentifier": "签出识别方式",
    "enableCheckInIdValidationPersona": "启用签到身份验证（Persona）",
    "requireCheckInIdValidationToCompleteCheckIn": "要求通过签到身份验证才能完成签到",
    "checkInIdValidationTemplate": "签到身份验证模板",
    "geofenceRadius": "地理围栏半径",
    "createAppointmentOnExternalValidationFailure": "外部验证失败时仍创建预约",
    "enableOverrideLimiterFunction": "启用限制器覆盖功能",
    "receiveUnplannedCheckInEmailNotifications": "接收计划外签到的电子邮件通知",
    "driversMustEnterAReferenceNumberToCheckIn": "司机必须输入参考号才能签到",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "只有当参考号与已安排的预约匹配时，司机才能签到",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "司机在签到时跳过参考号步骤",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "自定义司机签到后收到的第一条短信（可选）",
    "includeYardMapImageInTheFirstCheckInSms": "是否在第一条签到短信中包含堆场地图图片？",
    "automaticallyDeleteStoredIdValidations": "自动删除已存储的身份验证记录",
    "deleteStoredIdValidationsAfter": "已存储的身份验证记录删除期限",
    "displayDatesAs": "日期显示格式：",
    "displayTimeAs": "时间显示格式："
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "每个预约至少需要此数量的参考号",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "每个预约最多允许此数量的参考号",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "参考号字段的显示名称。例如：“PO 号”、“货运 ID”",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "帮助填写参考号字段的附加信息。例如：“参考号应以 OD-XX 开头”",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "所有预约都必须填写参考号",
    "thisOnlyAffectsNewlyCreatedAppointments": "此设置仅影响新建的预约",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "在预约门户中进行预约时，时长会显示在货物类型选择列表中",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "允许在预约门户中进行预约时选择站台",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "此设置允许在“已到达”和“已完成”之间选择额外的“进行中”状态",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "确定此组织的所有用户在整个平台（包括预约网格和报表）中看到的时间显示方式。",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "启用后将切换到新的可自定义预约详情系统",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "用户对网格卡片显示方式的配置。",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "此设置会请求获取司机的位置，并在司机距离您的仓库超过一英里时禁止其签到。",
    "preventCarriersFromReschedulingAppointmentsOptional": "禁止承运商改期预约。（可选）",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "当承运商改期“已预约”的预约时，将其恢复为“已申请”以重新审批",
    "attributeToBeUsedForMatchingObservations": "用于匹配观测记录的属性",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "在签到时间前后计入观测记录的分钟数",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "承运商可在预约开始时间之前多少分钟签到",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "承运商可在预约开始时间之后多少分钟内签到",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "接收技术问题和信息的电子邮件地址",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "发生验证服务器错误时，向技术联系人发送通知的时间间隔。",
    "aListOfMutedAppointmentNotifications": "已静音的预约通知列表。",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "所有预约的参考号都必须唯一",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "这是预约可开始时间之间的间隔分钟数",
    "enableTheCustomAppointmentStartTimesSetting": "启用自定义预约开始时间设置",
    "theInputModeForTheReferenceNumberField": "参考号字段的输入模式",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "单元类型字段的显示名称。例如：托盘数量、垫木数量",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "所有预约都必须填写单元类型字段",
    "autoDepartAssetsOnReceivingOutgateEvent": "收到出闸事件时自动将资产设为离场",
    "autoCreateAssetsOnReceivingIngateEvent": "收到入闸事件时自动创建资产",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "AI Gate Feed 页面中可用的列。必填列始终显示。",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "即使预约验证未通过也创建预约",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "司机签到时必须位于的半径范围（英里）。仅在启用地理围栏时适用。",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "帮助填写单元类型字段的附加信息。例如：单元类型只能为数字",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "设置预约中装卸单元字段可输入的最大数值",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "设置预约中装卸单元字段可输入的最小数值",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "当达到限制器上限的 100% 时，此功能仅允许仓库用户覆盖限制，并创建或批准预约和单元",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "系统用于验证签出表单的资产属性",
    "enforceBolSigningOnCheckOutForm": "在签出表单上强制签署 BOL",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "如果 BOL 不可用，承运商将无法签署，签出也会因此受阻。您可以在此设置发生这种情况时向司机显示的自定义说明。",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "在签到流程中显示 Persona 组件以进行身份验证",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "要求司机在完成签到之前成功通过 Persona 验证",
    "personaTemplateUsedForCheckInIdentityVerification": "用于签到身份验证的 Persona 模板",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "发生计划外签到时，仓库订阅者将收到电子邮件通知",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "此消息将替换通过短信发送给司机的默认签到确认文本。留空则使用默认消息。",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "在签到短信之后立即以单独的图片消息发送您的堆场地图。需要为该仓库上传堆场地图。",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "保留期满后，已存储的身份验证记录将被永久删除",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "已存储的身份验证记录在删除前保留的天数",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "确定此公司的用户在面向公司的各项体验中看到的日期显示方式。",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "确定此公司的用户在面向公司的各项体验中看到的时间显示方式。"
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "与预约关联的参考号",
    "insertMessageHere": "在此输入消息"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "整点（:00）",
      "topAndBottomOfTheHour00And30": "整点和半点（:00 和 :30）",
      "everyTwentyMinutes0020And40": "每二十分钟（:00、:20 和 :40）",
      "everyQuarterOfTheHour001530And45": "每刻钟（:00、:15、:30 和 :45）",
      "customStartTimes": "自定义开始时间"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 分钟",
      "30Minutes": "30 分钟",
      "60Minutes": "60 分钟",
      "90Minutes": "90 分钟"
    },
    "observationMatchAttribute": {
      "licensePlate": "车牌号",
      "dotNumber": "DOT 编号",
      "any": "任意",
      "cascade": "级联"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "字母数字",
      "numeric": "数字"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "已预约",
      "requested": "已申请"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "进行中",
      "completed": "已完成"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "否，不包含参考号字段",
      "yesIncludeTheReferenceNumberField": "是，包含参考号字段"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "否，不隐藏货物类型时长",
      "yesHideTheLoadTypeDuration": "是，隐藏货物类型时长"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "否，禁用预约通知",
      "yesEnableAppointmentNotifications": "是，启用预约通知"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "否，不允许选择站台",
      "yesAllowTheDockSelection": "是，允许选择站台"
    },
    "displayTimeIn": {
      "regularTime12Hour": "常规时间（12 小时制）",
      "militaryTime24Hour": "24 小时制时间"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "允许在预约门户中改期",
      "preventReschedulingInTheSchedulingPortal": "禁止在预约门户中改期"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "承运商改期时恢复为“已申请”",
      "keepStatusUnchangedOnCarrierReschedule": "承运商改期时保持状态不变"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "否，不将参考号设为必填字段",
      "yesMakeReferenceNumberARequiredField": "是，将参考号设为必填字段"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "否，不要求参考号唯一",
      "yesRequireUniqueReferenceNumbers": "是，要求参考号唯一"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "否，不将装卸单元设为必填字段",
      "yesMakeHandlingUnitsARequiredField": "是，将装卸单元设为必填字段"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "否，不包含装卸单元字段",
      "yesIncludeTheHandlingUnitsField": "是，包含装卸单元字段"
    },
    "checkOutIdentifier": {
      "licensePlate": "车牌号",
      "phoneNumber": "电话号码",
      "any": "任意"
    },
    "enableCheckInIdValidationPersona": {
      "no": "否",
      "yes": "是"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "否",
      "yes": "是"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "驾驶证 - 正面 - 1 次重试",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "驾驶证 - 正面、条形码、人脸，仅限美国，1 次重试"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "否",
      "yes": "是"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "周二, MM/DD/YYYY",
      "tueDdMmYyyy": "周二, DD/MM/YYYY",
      "tueYyyyMmDd": "周二, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 小时制（例如 7:00 AM）",
      "24HourEG0700": "24 小时制（例如 07:00）"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "例如 7:00 AM / 7:00 PM",
      "eG07001900": "例如 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "注意：",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "如果留空，将使用默认名称",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "如果留空，将使用默认帮助文本",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "启用此选项不会影响已在单个预约级别禁用的通知。",
    "ifLeftEmptyNoNotificationsWillBeSent": "如果留空，将不会发送任何通知",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "分配给已取消或未到场预约的参考号可在新预约中重复使用",
    "ifEmptyTheDefaultNameWillBeApplied": "如果为空，将使用默认名称"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "司机",
    "checkInSms": "签到短信",
    "dataRetention": "数据保留"
  }
}
